document.addEventListener('DOMContentLoaded', function () {
  const customText = document.getElementById('customText');
  const customText2 = document.getElementById('customtext2');
  const addToCartBtn = document.querySelector('form[action*="/cart/add"] [type="submit"]');

  if (customText) {
    // Live remove red border while typing
    customText.addEventListener("click", function () {
      customText.classList.remove("required");
    });
  }

  if (customText && customText2) {
    // Copy live input changes
    customText.addEventListener('input', function () {
      customText2.value = customText.value;
    });

    // Also copy initial value (if any)
    customText2.value = customText.value;
  }

  if (addToCartBtn && customText) {
    addToCartBtn.addEventListener("click", function(event) {
      if (customText.value.trim() === "") {
        event.preventDefault(); // Stop form submission
        customText.classList.add("required");
        customText.focus();
      }
    });
  }
  customText.addEventListener("input", function () {
   if (customText.value.trim() === "") {
      customText.classList.add("required");
    } else {
      customText.classList.remove("required");
    }
  });
});
